<div>
  <div *ngIf="!selectedBike && !newBike && !transferBikes">
    <div class="row table-toolbar">
      <div class="col-md-9">
        <div class="search-bar">
          <hub-input [(ngModel)]="searchTerm" (ngModelChange)="onSearchChanged()" [icon]="'search'" [iconColor]="'#888888'" [allowClear]="true"
                     placeholder="{{ 'general.search' | translate }}"></hub-input>
        </div>
      </div>
      <div class="col-md-2 transfer-btn-col">
        <hub-button
          *ngIf="selectedBikes.length > 0 && partnerData.AllowItemTransfers"
          [text]="'Transfer ' + selectedBikes.length + ' item' + (selectedBikes.length === 1 ? '' : 's')"
          [style]="'secondary'"
          [size]="'md'"
          (buttonClick)="transferSelected()">
        </hub-button>
      </div>
      <div class="col-md-1">
        <div pTooltip="{{ 'bikeshop.modal.add_edit_user.bikes_form.add_new_bike' | translate }}"
             tooltipPosition="left"
             class="fa hubtiger-add font-button pull-right" (click)="newBike=true"></div>
      </div>
    </div>
    <p-table #bikesTable [columns]="columns" [value]="bikes" [loading]="loading">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th style="width: 44px;">
            <p-checkbox [binary]="true" [ngModel]="isAllSelected()" (ngModelChange)="toggleSelectAll()"></p-checkbox>
          </th>
          <th *ngFor="let col of columns" [pSortableColumn]="col.type !== 'action' ? col.field : ''">
            {{col.header}}
            <p-sortIcon [field]="col.field" style="vertical-align: middle;" *ngIf="col.type !== 'action'">
            </p-sortIcon>
          </th>
          <th style="width: 60px;"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-bike let-columns="columns">
        <tr [pSelectableRow]="bike" [ngClass]="{'highlight-text': singleBike && bikeId && bike.ID===bikeId}">
          <td>
            <p-checkbox [binary]="true" [ngModel]="isBikeSelected(bike)" (ngModelChange)="toggleBikeSelection(bike)"></p-checkbox>
          </td>
          <td *ngFor="let col of columns">
            <div *ngIf="col.type!=='action'">
              {{
                col.type === "km" ?
                  bike[col.field] + ' ' + distanceMetric :
                  col.type === "time" ?
                    (bike[col.field] | number : '.0-0') + 'Hrs' :
                    col.type === "date" ?
                      (bike[col.field] | date : countryData.AngularDateFormat) :
                      col.type === "string" && col.field === "year" && bike[col.field] == "0" ?
                        "" :
                        bike[col.field] == "0" ? "" : bike[col.field]
              }}
            </div>
          </td>
          <td style="text-align:left;">
            <div pTooltip="{{ 'bikeshop.modal.add_edit_user.bikes_form.view_bike_details' | translate }}"
                 tooltipPosition="left" class="fa fa-cube font-button" style="font-size:24px;"
                 [ngClass]="{'service-due': bike.dueForService}" (click)="viewBike(bike)"></div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <p-paginator [rows]="limit" [totalRecords]="totalRecords" [first]="page * limit"
                 (onPageChange)="paginate($event)"></p-paginator>
  </div>
  <div *ngIf="selectedBike">
    <div class="row">
      <div class="col-md-3">
        <button pButton type="button" class="p-button-raised no-border icon" icon="pi pi-chevron-left"
                iconPos="left" style="width: 100%"
                label="{{ 'bikeshop.modal.add_edit_user.bikes_form.back_to_all_bikes' | translate }}"
                (click)="selectedBike=null; getBikes()"></button>
      </div>
      <div class="col-md-3" *ngIf="partnerData.AllowItemTransfers">
        <button pButton type="button" class="p-button-raised no-border icon" icon="pi pi-arrow-right-arrow-left"
                iconPos="left" style="width: 100%"
                label="{{ 'customer.item.edit_item.transfer' | translate }}"
                (click)="showTransfer=!showTransfer;"></button>
      </div>
    </div>
    <div class="margin-top-8" *ngIf="!showTransfer">
      <app-bike [bike]="selectedBike" [bikeGear]="bikeGear" [useNew]="true"></app-bike>
    </div>
    <div class="margin-top-8" *ngIf="showTransfer">
      <app-item-transfer [bike]="selectedBike" [user]="cyclist" (completed)="setCompleted($event)"></app-item-transfer>
    </div>
  </div>
  <div *ngIf="newBike">
    <div>
      <div class="col-md-3">
        <button pButton type="button" class="p-button-raised no-border icon" icon="pi pi-chevron-left"
                iconPos="left"
                label="{{ 'bikeshop.modal.add_edit_user.bikes_form.back_to_all_bikes' | translate }}"
                (click)="newBike=null;"></button>
      </div>
    </div>
    <div>
      <app-cyclist-bike [user]="cyclist" (update)="newBike=null;getBikes();">
      </app-cyclist-bike>

    </div>
  </div>
  <div *ngIf="transferBikes">
    <app-item-transfer [bikes]="selectedBikes" [user]="cyclist" (completed)="setCompleted($event)"></app-item-transfer>
  </div>
</div>
